var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManual({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6999 6.29974C13.5166 6.48666 13.414 6.73798 13.414 6.99974C13.414 7.26149 13.5166 7.51281 13.6999 7.69974L15.2999 9.29974C15.4868 9.48296 15.7381 9.58559 15.9999 9.58559C16.2616 9.58559 16.5129 9.48296 16.6999 9.29974L20.4699 5.52974C20.9727 6.64092 21.1249 7.87897 20.9063 9.07888C20.6877 10.2788 20.1086 11.3836 19.2461 12.246C18.3837 13.1084 17.2789 13.6876 16.079 13.9062C14.8791 14.1248 13.641 13.9726 12.5299 13.4697L5.61986 20.3797C5.22203 20.7776 4.68246 21.0011 4.11986 21.0011C3.55725 21.0011 3.01768 20.7776 2.61986 20.3797C2.22203 19.9819 1.99854 19.4423 1.99854 18.8797C1.99854 18.3171 2.22203 17.7776 2.61986 17.3797L9.52986 10.4697C9.02702 9.35855 8.87477 8.1205 9.0934 6.92059C9.31202 5.72068 9.89114 4.61589 10.7536 3.75346C11.616 2.89102 12.7208 2.3119 13.9207 2.09328C15.1206 1.87465 16.3587 2.0269 17.4699 2.52974L13.7099 6.28974L13.6999 6.29974Z",
    stroke: "#40506A",
    strokeOpacity: 0.43,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/Manual.307fd08225aea54139461df6b4e7bf96.svg";
export { ForwardRef as ReactComponent };